import { render, staticRenderFns } from "./BorrarSancion.vue?vue&type=template&id=591d6e99"
import script from "./BorrarSancion.vue?vue&type=script&lang=js"
export * from "./BorrarSancion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports